﻿﻿export interface IUpdateClusterLogisticsProvider {
    clusterId: number;
    logisticsProvider: number;
}
